import { useCallback, useMemo } from "react";
import { UserState } from "../context/auth";
import { useLocalStorage } from "./useLocalStorage";

export type HiddenColumns = Record<string, true | undefined>;
export const useColumnVisibility = (user: UserState) => {
  const storageKey = useMemo(
    () => `column-visibility-${user.id}-${user.client.id}`,
    [user]
  );
  const [stored, setStored] = useLocalStorage<HiddenColumns>(
    storageKey,
    {},
    true
  );

  const isVisible = useCallback(
    (columnId: string) => !stored[columnId],
    [stored]
  );

  const toggleColumns = (columnIds: string[]) => {
    const newState = { ...stored };
    columnIds.forEach((columnId) => {
      if (newState[columnId]) {
        delete newState[columnId];
      } else {
        newState[columnId] = true;
      }
    });
    setStored(newState);
  };

  return { isVisible, toggleColumns };
};
